import './index.css';

const LoadingSpinner = () => (
  <div className='loading-spinner'>
    <div className='spinner'></div>
    <p>Loading...</p>
  </div>
);

export default LoadingSpinner;
